var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { navigateToWithParams } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { loadTokens } from '@popup/steem/actions/token.actions';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { Screen } from '@reference-data/screen.enum';
import FlatList from 'flatlist-react';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CheckboxPanelComponent } from 'src/common-ui/checkbox/checkbox-panel/checkbox-panel.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
import FormatUtils from 'src/utils/format.utils';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const TokensFilter = ({ tokens, loadTokens, setTitleContainerProperties, }) => {
    const [filterValue, setFilterValue] = useState('');
    const [filteredTokens, setFilteredTokens] = useState([]);
    const [hiddenTokens, setHiddenTokens] = useState([]);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_tokens_available',
            isBackButtonEnabled: true,
        });
        loadHiddenTokens();
        loadTokens();
    }, []);
    const loadHiddenTokens = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setHiddenTokens((_a = (yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.HIDDEN_TOKENS))) !== null && _a !== void 0 ? _a : []);
    });
    const toggleHiddenToken = (symbol) => __awaiter(void 0, void 0, void 0, function* () {
        let newHiddenTokens = hiddenTokens;
        if (hiddenTokens.includes(symbol)) {
            newHiddenTokens = newHiddenTokens.filter((hiddenToken) => hiddenToken !== symbol);
        }
        else {
            newHiddenTokens = [...newHiddenTokens, symbol];
        }
        setHiddenTokens(newHiddenTokens);
        yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.HIDDEN_TOKENS, newHiddenTokens);
    });
    useEffect(() => {
        if (tokens) {
            const filterValueLowerCase = filterValue.toLowerCase();
            setFilteredTokens(tokens.filter((token) => token.name.toLowerCase().includes(filterValueLowerCase) ||
                token.symbol.toLowerCase().includes(filterValueLowerCase) ||
                token.issuer.toLowerCase().includes(filterValueLowerCase)));
        }
    }, [tokens, filterValue]);
    return (React.createElement("div", { "data-testid": `${Screen.TOKENS_FILTER}-page`, className: "tokens-filter" },
        React.createElement("div", { "data-testid": "tokens-filter-disclaimer", className: "caption", dangerouslySetInnerHTML: {
                __html: getMessage('popup_html_tokens_settings_text'),
            } }),
        React.createElement(InputComponent, { classname: "input-filter", dataTestId: "input-filter-box", type: InputType.TEXT, placeholder: "popup_html_search", value: filterValue, onChange: setFilterValue, rightActionIcon: SVGIcons.INPUT_SEARCH, rightActionClicked: () => { } }),
        React.createElement("div", { className: "tokens-list" }, filteredTokens.length ? (React.createElement(FlatList, { list: filteredTokens, renderItem: (token) => {
                var _a;
                return (React.createElement("div", { "data-testid": `token-list-item-${token.symbol}`, className: "token", key: token.symbol },
                    React.createElement(CheckboxPanelComponent, { dataTestId: `checkbox-select-token-${token.symbol}`, extraDataTestIdOnInput: `checkbox-checked-${token.symbol}`, checked: !hiddenTokens.includes(token.symbol), onChange: () => {
                            toggleHiddenToken(token.symbol);
                        } },
                        React.createElement("div", { "data-testid": "token-list-item-description", className: "description" },
                            React.createElement("div", { className: "name" }, token.name),
                            React.createElement("div", { className: "extra-info" },
                                React.createElement("div", { className: "details" },
                                    React.createElement("div", { className: "logo-container" },
                                        React.createElement("img", { className: "logo", src: (_a = token.metadata.icon) !== null && _a !== void 0 ? _a : '/assets/images/wallet/steem-engine.svg', onError: ({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src =
                                                    '/assets/images/wallet/steem-engine.svg';
                                            } })),
                                    token.issuer && (React.createElement("div", { className: "issued-by" },
                                        token.symbol,
                                        ' ',
                                        getMessage('popup_token_issued_by', [
                                            token.issuer,
                                        ])))),
                                React.createElement("div", { className: "supply" },
                                    getMessage('popup_token_supply'),
                                    ' : ',
                                    FormatUtils.nFormatter(parseFloat(token.supply), 3),
                                    "/",
                                    FormatUtils.nFormatter(parseFloat(token.maxSupply), 3)))))));
            }, renderOnScroll: true })) : null)));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
        tokens: state.steem.tokens,
    };
};
const connector = connect(mapStateToProps, {
    navigateToWithParams,
    loadTokens,
    setTitleContainerProperties,
});
export const TokensFilterComponent = connector(TokensFilter);
